import React, {useEffect, useState} from "react";
import "../App.css";

import Axios from "axios";
import Select from 'react-select'
import { useNavigate } from "react-router-dom";

import { MDBInput, MDBSwitch, MDBTextArea, MDBBtn } from "mdb-react-ui-kit";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import de from 'react-phone-input-2/lang/de.json'

import {
    ageRanges,
    ageRangeToBirthday, backendPathAuth,
    backendPathEmployees,
    backendPathPartners,
    germanLevels,
    ratings
} from "../Constants";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";


const regionNames = new Intl.DisplayNames(
    ['de'], { type: 'region' }
);


function NewEmployee() {
    const navigate = useNavigate();

    const [partners, setPartners] = useState([]);

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [birthday, setBirthday] = useState();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [license, setLicense] = useState(0);
    const [smoker, setSmoker] = useState(0);
    const [germanLevel, setGermanLevel] = useState(-1);
    const [actualGermanLevel, setActualGermanLevel] = useState(-1);
    const [rating, setRating] = useState(-1);
    const [ratingAnnotation, setRatingAnnotation] = useState("");
    const [recommendation, setRecommendation] = useState(0);
    const [taskAnnotation, setTaskAnnotation] = useState("");
    const [escalation, setEscalation] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [partnerID, setPartnerID] = useState(0);
    const [partnerLabel, setPartnerLabel] = useState("");
    const [nationality, setNationality] = useState("");

    const [submitted, setSubmitted] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getPartners = () => {
        Axios.get(backendPathPartners+"partners.php").then((response) => {
            setPartners(response.data.map((val, key) => {
                console.log(response.data);
                return {label: val.Name, value: val.PartnerID };
            }));
        });
    };

    const checkCompleteness = () => {
        if (!name || !surname || !birthday || !phoneNumber || germanLevel<0) {
            console.log("incomplete");
            return false;
        }
        return true;
    };

    const addEmployee = () => {
        setSubmitted(true);

        if (!checkCompleteness()) {
            return;
        }

        Axios.get(backendPathEmployees+"create-employee.php", {
            params: {
                name: name,
                surname: surname,
                birthday: birthday,
                phoneNumber: phoneNumber,
                license: license,
                smoker: smoker,
                germanLevel: germanLevel,
                actualGermanLevel: actualGermanLevel,
                rating: rating,
                ratingAnnotation: ratingAnnotation,
                recommendation: recommendation,
                taskAnnotation: taskAnnotation,
                escalation: escalation,
                annotation: annotation,
                partnerId: partnerID,
                nationality: nationality,
            }
        }).then((response) => {
            console.log(response);
            console.log(name, surname, birthday, phoneNumber, license, smoker, germanLevel, actualGermanLevel, rating, ratingAnnotation, recommendation, taskAnnotation, escalation, annotation, partnerLabel);
            navigate("/employees");
        });
    };


    useEffect(() => {
        getPartners();
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

            <div className="main">
                <div className="header">
                    <h2>Neue Betreuungskraft anlegen</h2>
                </div>

                <div className='input-form'>
                    <MDBInput className="input" label='Vorname' color="primary" id='form1' type='text'
                              onChange={(event) => {
                                  setName(event.target.value);
                              }}/>
                    {(submitted && !name) ?
                        <p className="validation-label">Vorname darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input" label='Nachname' id='form2' type='text' onChange={(event) => {
                        setSurname(event.target.value);
                    }}/>
                    {(submitted && !surname) ?
                        <p className="validation-label">Nachname darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Partner</p>
                    <Select className="input" id="select1" placeholder={'Auswählen...'} options={partners}
                            value={partnerID ? {label: partnerLabel, value: partnerID} : null} onChange={(event) => {
                        console.log(event);
                        setPartnerID(event.value);
                        setPartnerLabel(event.label);
                    }}/>

                    <p className="input-label">Alter</p>
                    <Select className="input" id="select2" placeholder={'Auswählen...'} options={ageRanges}
                            onChange={(event) => {
                                setBirthday(ageRangeToBirthday(event.value));
                            }}/>
                    {(submitted && !birthday) ?
                        <p className="validation-label">Alter darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Telefon</p>
                    <PhoneInput
                        className="input"
                        localization={de}
                        country='de'
                        enableSearch={true}
                        searchPlaceholder={'Suchen'}
                        onChange={(value, c, e, formattedValue) => {
                            setPhoneNumber(formattedValue);
                            setNationality(regionNames.of(c.countryCode));
                        }}
                    />
                    {(submitted && !phoneNumber) ?
                        <p className="validation-label">Telefonnummer darf nicht leer sein.</p> : null
                    }

                    <div className="input"><MDBSwitch id='licenseSwitch' label='Führerschein vorhanden'
                                                      onChange={(event) => {
                                                          setLicense(s => (s + 1) % 2);
                                                      }}/></div>

                    <div className="input"><MDBSwitch id='smokerSwitch' label='Raucher/in' onChange={(event) => {
                        setSmoker(s => (s + 1) % 2);
                    }}/></div>

                    <p className="input-label">angegebene Deutschkenntnisse</p>
                    <Select className="input" id="select3" placeholder={'Auswählen...'} options={germanLevels}
                            onChange={(event) => {
                                setGermanLevel(event.value);
                            }}/>
                    {(submitted && germanLevel < 0) ?
                        <p className="validation-label">Deutschkenntnisse darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">tatsächliche Deutschkenntnisse</p>
                    <Select className="input" id="select4" placeholder={'Auswählen...'} options={germanLevels}
                            onChange={(event) => {
                                setActualGermanLevel(event.value);
                            }}/>

                    <p className="input-label">Bewertung</p>
                    <Select className="input" id="select5" placeholder={'Auswählen...'} options={ratings}
                            onChange={(event) => {
                                setRating(event.value);
                            }}/>

                    <MDBTextArea className="input" label='Bemerkung zu der Bewertung' id='textAreaExample' rows={4}
                                 onChange={(event) => {
                                     setRatingAnnotation(event.target.value);
                                 }}/>

                    <div className="input"><MDBSwitch id='recommendedSwitch' label='für erneute Einsätze empfohlen'
                                                      onChange={(event) => {
                                                          setRecommendation(s => (s + 1) % 2);
                                                      }}/></div>

                    <MDBTextArea className="input" label='Bemerkung für erneute Einsätze' id='textAreaExample' rows={4}
                                 onChange={(event) => {
                                     setTaskAnnotation(event.target.value);
                                 }}/>

                    <MDBTextArea className="input" label='Eskalationen' id='textAreaExample' rows={4}
                                 onChange={(event) => {
                                     setEscalation(event.target.value);
                                 }}/>

                    <MDBTextArea className="input" label='Notizen' id='textAreaExample' rows={4} onChange={(event) => {
                        setAnnotation(event.target.value);
                    }}/>
                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={addEmployee}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default NewEmployee;